module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAIIAAAAKCAMAAABPPnZ6AAAAZlBMVEUAAADJpJLIp5LJpJPJpJJXUFNJRUwrLztwZGKGdW6CcWthWFldVVc0NUCPe3KLeHB9bml5a2Z1aGRpXl1STFBOSU5EQklAP0Y8PEQ4OUKahHllW1uXgneUf3VsYV8wMj6dh3uSfnSFU7eaAAAABHRSTlMA2mKlwvqIPgAAALhJREFUOMvV1NkOgjAQBVDAsnRjK903+P+ftBJRY6IvmID3vTMnbWeyfSlyAPIiOzAXsOaSHZYC3HPcPeQbId9Vpq7rGCnVWikphaiqivNpKsuSEIKxtYyFpmnGcRj6HiEEYde17eK9M/MMHpmNcd4vbdt1EEKE+n4YxjEdDIFZizEmJJWcJs5TAyGkVEprSmNM7VcC/UxgiRCeBLgRnDPmjeA2AnolsG8EeiOc4SH+/DueYCh/s5quGV8RNgX1dT4AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/vip-declare@2x.png
// module id = TqCD
// module chunks = 1